import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=616e3812&scoped=true&"
import script from "./ChatBox.ts?vue&type=script&lang=ts&"
export * from "./ChatBox.ts?vue&type=script&lang=ts&"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=616e3812&lang=vue-scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e3812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616e3812')) {
      api.createRecord('616e3812', component.options)
    } else {
      api.reload('616e3812', component.options)
    }
    module.hot.accept("./ChatBox.vue?vue&type=template&id=616e3812&scoped=true&", function () {
      api.rerender('616e3812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/typo3conf/ext/aus_project/Resources/Private/TypeScript/ChatBox/Components/ChatBox.vue"
export default component.exports